import React from 'react'

const Container = ({children}:React.PropsWithChildren) => {
  return (
    <div className='p-3 w-full'>
      {children}
    </div>
  )
}

export default Container
